var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41537",
    "data-name": "Group 41537",
    transform: "translate(17129 -1956)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15753",
    "data-name": "Rectangle 15753",
    width: 16,
    height: 16,
    transform: "translate(-17129 1956)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "user_12_",
    "data-name": "user (12)",
    transform: "translate(-17130.5 1954.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2964",
    "data-name": "Ellipse 2964",
    cx: 3.891,
    cy: 3.891,
    r: 3.891,
    transform: "translate(5.609 2.5)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37106",
    "data-name": "Path 37106",
    d: "M9.5,61.875c-3.867,0-7,1.575-7,3.5v1.75h14v-1.75C16.5,63.45,13.368,61.875,9.5,61.875Z",
    transform: "translate(0 -50.625)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFilled);
export default __webpack_public_path__ + "static/media/user-filled.4e589348477cefd3375b9fa74d4ce116.svg";
export { ForwardRef as ReactComponent };